/** UUID v4 for correlation and idempotency; always use cryptographic randomness. */
export function uuidFromRandomValues(provider: Pick<Crypto, "getRandomValues">): string {
  const bytes = provider.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}
export function createUuid(): string {
  const provider = globalThis.crypto;
  if (typeof provider?.randomUUID === "function") return provider.randomUUID();
  if (typeof provider?.getRandomValues === "function") return uuidFromRandomValues(provider);
  throw new Error("当前浏览器无法生成安全标识，请使用 HTTPS 或本机地址访问。");
}
export function installUuidCompatibility() {
  const provider = globalThis.crypto;
  if (provider && typeof provider.randomUUID !== "function" && typeof provider.getRandomValues === "function") {
    Object.defineProperty(provider, "randomUUID", { configurable: true, value: () => uuidFromRandomValues(provider) });
  }
}

/** Stable correlation ID even when browser storage is blocked or full. */
export function createStoredUuid(key: string, storage: () => Pick<Storage, "getItem" | "setItem"> = () => window.localStorage) {
  let reference: string | undefined;
  const valid = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/;
  return () => {
    if (reference) return reference;
    reference = createUuid();
    try {
      const local = storage();
      const stored = local.getItem(key);
      if (stored && valid.test(stored)) return reference = stored;
      local.setItem(key, reference);
    } catch { /* Keep the in-memory identity when storage is unavailable. */ }
    return reference;
  };
}
